const INTERACTIVE_SELECTOR =
  "button, a, input, textarea, select, option, label, summary, [contenteditable='true'], [data-no-card-nav='true']";

/**
 * Guards card-level navigation when the user is selecting text,
 * dragging, or clicking inside nested interactive controls.
 *
 * @param {MouseEvent | React.MouseEvent} event
 * @param {{ dragged?: boolean }} [opts]
 * @returns {boolean}
 */
export function shouldIgnoreNavigationClick(event, opts = {}) {
  if (!event) return false;
  const dragged = Boolean(opts.dragged);

  const selectionText =
    typeof window !== "undefined" && window.getSelection
      ? String(window.getSelection()?.toString?.() || "").trim()
      : "";

  if (selectionText.length > 0) return true;
  if (dragged) return true;
  if (event.detail === 0) return true;

  const target = event.target;
  if (target && typeof target.closest === "function") {
    const interactiveRoot = target.closest(INTERACTIVE_SELECTOR);
    if (interactiveRoot && interactiveRoot !== event.currentTarget) return true;
  }

  return false;
}

export default shouldIgnoreNavigationClick;
